import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "sidebar" }
const _hoisted_2 = ["aria-expanded", "onClick"]
const _hoisted_3 = { class: "section__name" }
const _hoisted_4 = { class: "section__list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "sidebar__title" }, "Документация", -1)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sections, (section) => {
      return (_openBlock(), _createElementBlock("div", {
        key: section.title,
        class: "section"
      }, [
        _createElementVNode("button", {
          type: "button",
          class: "section__header",
          "aria-expanded": _ctx.isOpen(section.title),
          onClick: ($event: any) => (_ctx.toggle(section.title))
        }, [
          _createElementVNode("span", {
            class: _normalizeClass(["section__caret", { 'section__caret--open': _ctx.isOpen(section.title) }])
          }, "▶", 2),
          _createElementVNode("span", _hoisted_3, _toDisplayString(section.title), 1)
        ], 8, _hoisted_2),
        _withDirectives(_createElementVNode("ul", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.docs, (doc) => {
            return (_openBlock(), _createElementBlock("li", {
              key: doc.id
            }, [
              _createVNode(_component_router_link, {
                class: "doc-link",
                to: `/doc/${encodeURIComponent(doc.id)}`
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(doc.title), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ]))
          }), 128))
        ], 512), [
          [_vShow, _ctx.isOpen(section.title)]
        ])
      ]))
    }), 128))
  ]))
}